import React, { Component, useState, useEffect } from 'react'

function CssContent({ containerObject, templateName, contentId, dataZone }) {
  const [ContTitle, setContTitle] = useState('')
  useEffect(() => {
    var hash = window.location.hash;
    if (hash) {
      var element = document.querySelector(hash);
      if (element) {
        element.scrollIntoView({ behavior: "smooth" });
      }
    }

  }, [])
  return (
    <div data-cont-id={containerObject.contentId} 
    style={containerObject?containerObject.backgroundImage?{ backgroundImage: `url(${containerObject.backgroundImage})`}:{}:{}}
    //style={{ backgroundImage: `url(${containerObject.backgroundImage})`, width: '100%' }} 
    data-zone={dataZone} data-page-id={contentId} data-template-name={templateName}
     className={`vast-plugin-content row mx-0 my-3 ${containerObject.attributes.class ? containerObject.attributes.class : containerObject.attributes.articleContainerRendering ? containerObject.attributes.articleContainerRendering : ("col-md-12")}`} id={containerObject.attributes.ArticleId ?containerObject.attributes.ArticleId :""}>
     <span className={`${containerObject.attributes.horizontalLine ? containerObject.attributes.horizontalLine :"" }`}> </span>
       {containerObject.cssContent? containerObject.cssContent :""}
        
    </div>
    
  )
}

export default CssContent
